var inViewport = {
    init() {
      $(window).on('load', function () {
        // let els = document.getElementsByClassName('js-in-viewport');
  
        // for (var i = 0; i < els.length; i++) {
        //   if (($(window).outerHeight() * 0.5 + $(window).scrollTop()) > els[i].offsetTop) {
        //     console.log(i);
        //     // console.log($(els[i]));
        //     $(els[i]).delay(i * 500).addClass('in-viewport');
        //   }
        // }
  
  
        $('.js-in-viewport').each(function (i) {
          if (($(window).outerHeight() * 0.8 + $(window).scrollTop()) > $(this).offset().top) {
            $(this).delay(i * 250).queue(function (next) {
              $(this).addClass('in-viewport');
              next();
            });
          }
        });
      }).on('scroll', function () {
        $('.js-in-viewport:in-viewport( -150 ):not(".in-viewport")').each(function () {
          $(this).addClass('in-viewport');
        });
      });
    },
  };
  
  export default inViewport;
  